import type { TextSizingConfigs } from './utils';
import { devices } from '../common/devices';
import { colors, darkThemeSelector, styled } from '../stitches.config';
import { Text } from './Text';

const smallVars = {
  touch: {
    size: 14,
    lineHeight: 20,
  },
  mouse: {
    size: 12,
    lineHeight: 16,
  },
} as const satisfies TextSizingConfigs;

const SmallBase = {
  color: colors.bodyNeutralLight,
  [darkThemeSelector]: {
    color: colors.bodyNeutralDark,
  },
  variants: {
    internal: {
      true: {
        color: colors.internalBodyLight,
        [darkThemeSelector]: {
          color: colors.internalBodyDark,
        },
      },
      false: {},
    },
  },
};

export const SmallSansSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${smallVars.touch.size}`,
      lineHeight: `$${smallVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${smallVars.mouse.size}`,
      lineHeight: `$${smallVars.mouse.lineHeight}`,
    },
  },
};

export const SmallMonoSizes = {
  '&': {
    [devices.touch]: {
      fontSize: `$${smallVars.touch.size - 1}`,
      lineHeight: `$${smallVars.touch.lineHeight}`,
    },

    [devices.mouse]: {
      fontSize: `$${smallVars.mouse.size - 1}`,
      lineHeight: `$${smallVars.mouse.lineHeight}`,
    },
  },
};

export const Small = styled(Text, SmallBase, {
  variants: {
    family: {
      regular: SmallSansSizes,
      monospace: SmallMonoSizes,
    },
  },
  defaultVariants: {
    family: 'regular',
  },
});
Small.displayName = 'Small';
